import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  private formsUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/FormsAPI';
  private websiteManagerUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/WebsiteContentAPI';

  constructor(private http: HttpClient) { }

  getFormsTree () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormsTree');
  };
  getRootForms () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getRootForms');
  };
  createForm (form) : Observable<Object> {
    return this.http.post(this.formsUrlBase + '/createForm', form);
  };
  updateForm (form) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateForm', form);
  };
  deleteForm (form) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteForm?Id=' + form.Id + "&Name=" + form.Name);
  };
  updateFormFields (form) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateFormFields', form);
  };
  deleteFormField (fieldId) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteFormField?id=' + fieldId);
  };
  getFormTypes () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormTypes');
  };
  getFormFieldTypes () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormFieldTypes');
  };

  getFormsFieldsEnumsTree () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormsFieldsEnumsTree');
  };
  getFormsFieldsEnums () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormsFieldsEnums');
  };
  createFormsFieldsEnum (enumObj) : Observable<Object> {
    return this.http.post(this.formsUrlBase + '/createFormsFieldsEnum', enumObj);
  };
  updateFormsFieldsEnum (enumObj) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateFormsFieldsEnum', enumObj);
  };
  deleteFormsFieldsEnum (enumObj) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteFormsFieldsEnum?Id=' + enumObj.Id + "&Name=" + enumObj.Name);
  };
  updateFormsFieldsEnumValues (id, values) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateFormsFieldsEnumValues?Id=' + id, values);
  };
  deleteFormsFieldsEnumValue (id) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteFormsFieldsEnumValue?Id=' + id);
  };

  getRootFormsTree () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getRootFormsTree/');
  };
  getFormInstances (id) : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormInstances/' + id);
  };
  updateFormInstance (formInstance, values) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateFormInstance?Id=' + formInstance.Id, values);
  };
  deleteFormInstance (formInstance) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteFormInstance?Id=' + formInstance.Id);
  };

  getForgetFormSubmitEventsTree () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormSubmitEventsTree');
  };
  getFormSubmitEventsTypes () : Observable<Object> {
    return this.http.get(this.formsUrlBase + '/getFormSubmitEventsTypes');
  };
  createFormSubmitEmailEvent (event) : Observable<Object> {
    return this.http.post(this.formsUrlBase + '/createFormSubmitEmailEvent', event);
  };
  updateFormSubmitEmailEvent (event) : Observable<Object> {
    return this.http.put(this.formsUrlBase + '/updateFormSubmitEmailEvent', event);
  };
  deleteFormSubmitEmailEvent (event) : Observable<Object> {
    return this.http.delete(this.formsUrlBase + '/deleteFormSubmitEmailEvent?Id=' + event.Id + "&Name=" + event.Name);
  };
  getTemplates () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/GetTemplates');
  };

  printForm (id) {
    window.open(this.formsUrlBase + '/PrintForm/' + id, '_blank');
  };
}
